import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../../utils/api';

// Query Keys
export const powerMeterQueryKeys = {
  all: ['powerMeters'],
  lists: (id, params) => [...powerMeterQueryKeys.all, 'list', id, params],
  list: (id, params) => [...powerMeterQueryKeys.lists(id, params)],
  listYesterday: (id, params) => [...powerMeterQueryKeys.lists(id, params), 'yesterday'],
};

// 전력 미터 목록 조회 (실시간)
export const usePowerMeterDemand = (id, params = {}) => {
  return useQuery({
    queryKey: powerMeterQueryKeys.list(id, params),
    queryFn: async () => {
      try {
        const response = await api.get(`/drivecore/pd/api/LivePowerMeterDemand/${id}`, { params });
        return response || null;
      } catch (error) {
        console.error('PowerMeterDemand API Error:', error);
        return null;
      }
    },
    enabled: !!id,
    retry: 1,
    retryDelay: 1000,
  });
};

// 전력 미터 목록 조회 (어제)
export const usePowerMeterDemandYesterday = (params = {}) => {
  return useQuery({
    queryKey: powerMeterQueryKeys.listYesterday(params),
    queryFn: async () => {
      try {
        const response = await api.post(`/drivecore/pd/api/PowerMeterDemand/pack`, params);
        return response || null;
      } catch (error) {
        console.error('PowerMeterDemandYesterday API Error:', error);
        return null;
      }
    },
    retry: 1,
    retryDelay: 1000,
  });
};
